"use strict";

import $ from 'jquery';
import Widgets from 'js-widget-hooks';
import mUtils from '../util/modal-utils';
import React from 'react';
import ReactDOM from 'react-dom';
import MapsWidget from '../modules/MapsWidget.jsx';

Widgets.register('custom-location-popup', function(el){

    var elem = $(el),
        target = $(elem.data('target')),
        lat = elem.data('latitude'),
        lon = elem.data('longitude'),
        title = elem.data('title'),
        modalId = target.attr('id') + '-modal',
        locations = [{
            displayName: title,
            location: {
                geo: { latitude: lat, longitude: lon}
            },
            latitude: lat,
            longitude: lon
        }],

        modal
    ;

    elem.click(function(e) {
        e.preventDefault();

        if (! mUtils.open(modalId)) {
            var popupTemplate =
                '<div class="modal fade" id="' + modalId + '">' +
                '  <div class="modal-dialog  modal-lg">' +
                '    <div class="modal-content">' +
                '      <div class="modal-header">' +
                '        <button type="button" class="close" data-dismiss="modal">&times;</button>' +
                '        <h3 class="modal-title">' + title + '</h3>' +
                '      </div>' +
                '      <div class="modal-body">' +
                '           <div class="row">' +
                '               <div class="col-sm-6 map"></div>' +
                '               <div class="col-sm-6 content">' +
                target.html() +
                '               </div>' +
                '           </div>' +
                '      </div>' +
                '    </div>' +
                '  </div>' +
                '</div>'
            ;

            modal = mUtils.create(popupTemplate);
            modal.on('shown.bs.modal', function() {
                if (! elem.data('initialized')) {
                    elem.data('initialized', true);

                    ReactDOM.render(
                        <MapsWidget defaultZoom={14}
                                          defaultLatitude={lat}
                                          defaultLongitude={lon}
                                          centers={locations}
                        />,
                        modal.find('.map')[0]);
                }
            });
        }
    });
});